"use strict";
// Helper for passes that need to fill the viewport with a single quad.
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullScreenQuad = void 0;
const three_1 = require("three");
const _camera = new three_1.OrthographicCamera(-1, 1, 1, -1, 0, 1);
// https://github.com/mrdoob/three.js/pull/21358
const _geometry = new three_1.BufferGeometry();
_geometry.setAttribute("position", new three_1.Float32BufferAttribute([-1, 3, 0, -1, -1, 0, 3, -1, 0], 3));
_geometry.setAttribute("uv", new three_1.Float32BufferAttribute([0, 2, 0, 0, 2, 0], 2));
class FullScreenQuad {
    constructor(material) {
        this._mesh = new three_1.Mesh(_geometry, material);
    }
    dispose() {
        this._mesh.geometry.dispose();
    }
    render(renderer) {
        renderer.render(this._mesh, _camera);
    }
    get material() {
        return this._mesh.material;
    }
    set material(value) {
        this._mesh.material = value;
    }
}
exports.FullScreenQuad = FullScreenQuad;
//# sourceMappingURL=FullScreenQuad.js.map